import * as actions from '../constants/actionTypes';

export const INITIAL_STATE = {
  job: {},
  allJobs: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.CREATE_JOB_REQUEST_SUCCESS:
      return {
        ...state,
        job: action.payload,
      };

    case actions.GET_ALL_JOB_REQUEST_SUCCESS:
      return {
        ...state,
        allJobs: Array.isArray(action.payload) ? action.payload : [],
      };

    case actions.GET_JOB_REQUEST_SUCCESS:
      return {
        ...state,
        job: action.payload,
      };

    case actions.UPDATE_JOB_REQUEST_SUCCESS: {
      const next = action.payload && action.payload.data;
      if (!next || typeof next !== 'object') {
        return state;
      }
      return {
        ...state,
        job: { ...state.job, ...next },
      };
    }

    default:
      return state;
  }
};
